import React, { useState, useCallback, Fragment } from 'react';
import LoginForm from '@/components/ecom/Login';
import Otp from '@/components/ecom/Otp';
import Container from '@/shared/Container';
import PageLayout from '@/components/Layouts/PageLayout';
import AppBar from '@/shared/AppBar';
import BackgroundBlue from '@/components/Icons/BackgroundBlue';
import BackgroundBlueMobile from '@/components/Icons/BackgroundBlueMobile';
import { useRouter } from 'next/router';
import { MapType } from '@/types';
import useGTM from '@/hooks/useGTM';
import { GTMEventNames, SCREEN_NAMES } from '@/types/gtm';
import { ECOM_HOME_URL } from '@/configs/constants';

const loginData = {
  title: 'Enter registered mobile number',
  content: 'Use the mobile number used to purchase your Aquaguard device.',
};

const COMP_MAP: MapType = {
  login: LoginForm,
  otp: Otp,
};

const COMP_PROPS_MAP: MapType = {
  login: { loginData },
  otp: { loginData },
};

function LoginPage() {
  const [component, setComponent] = useState('login');
  const [mobileNumber, setMobileNumber] = useState<string | null>(null);
  const [userId, setUserId] = useState<string | null>(null);
  const { fireGTMEvent } = useGTM();

  const onLogin = useCallback((data: { mobile_number: string; userId: string }) => {
    setMobileNumber(data.mobile_number);
    setUserId(data.userId);
    setComponent('otp');
  }, []);

  const router = useRouter();
  const backButtonHandler = useCallback(() => {
    if (component === 'otp') {
      setComponent('login');
      fireGTMEvent(GTMEventNames.OTP_SCREEN_BACK_CLICKED, {
        screen_name: SCREEN_NAMES.LOGIN_OTP,
      });
      return;
    } else {
      router.push({
        pathname: ECOM_HOME_URL,
      });

      fireGTMEvent(GTMEventNames.LOGIN_SCREEN_BACK_CLICKED, {
        screen_name: SCREEN_NAMES.LOGIN_FORM,
      });
    }
  }, [router, setComponent, component]);

  const Comp = COMP_MAP[component] ?? Fragment;
  const compProps = COMP_PROPS_MAP[component] ?? {};

  return (
    <PageLayout hideFooter mainClassName="lg:min-h-screen bg-neutral-10 flex flex-col items-center">
      <BackgroundBlue className="fixed max-h-screen left-0 top-0 overflow-hidden hidden lg:block" />
      <BackgroundBlue className="fixed max-h-screen right-0 top-0 overflow-hidden hidden lg:block rotate-180" />
      <BackgroundBlueMobile className="fixed max-h-screen right-0 top-0 overflow-hidden lg:hidden" />
      <AppBar transparent fixed onClick={backButtonHandler} preventScrollBackground />
      <Container className="pt-8 max-w-xl md:max-w-md md:pt-28 z-[1]">
        <Comp
          mobileNumber={mobileNumber}
          userId={userId}
          boxNumber={4}
          onLogin={onLogin}
          {...compProps}
        />
      </Container>
    </PageLayout>
  );
}

export default LoginPage;
